/* ============================================================
   SURVIVRA — Shopify Theme JS
   ============================================================ */

'use strict';

// ===== CART DRAWER =====
function toggleCart() {
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if (!overlay || !drawer) return;
  overlay.classList.toggle('open');
  drawer.classList.toggle('open');
  document.body.style.overflow = drawer.classList.contains('open') ? 'hidden' : '';
}

// ===== ADD TO CART =====
async function addToCart(event, variantId, quantity = 1) {
  if (event) event.preventDefault();
  const btn = event?.currentTarget;
  if (btn) { btn.textContent = '…'; btn.disabled = true; }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (!response.ok) throw new Error('Erreur ajout panier');
    const item = await response.json();
    await refreshCart();
    showToast(`${item.title} ajouté au panier`);
    toggleCart();
  } catch (err) {
    console.error('Add to cart error:', err);
    showToast('Erreur — veuillez réessayer');
  } finally {
    if (btn) { btn.textContent = '+ Panier'; btn.disabled = false; }
  }
}

// ===== UPDATE CART QTY =====
async function updateCartQty(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Update failed');
    await refreshCart();
  } catch (err) {
    console.error('Cart update error:', err);
  }
}

// ===== REFRESH CART UI =====
// Source de vérité unique : /cart.js -> buildCartDrawer reconstruit tout le tiroir.
async function refreshCart() {
  try {
    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await response.json();

    // Badge compteur dans le header
    const countEl = document.getElementById('cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    // Reconstruit le tiroir (lignes + pied + progression + sous-total + compteur)
    buildCartDrawer(cart);

  } catch (err) {
    console.error('Cart refresh error:', err);
  }
}

function buildCartDrawer(cart) {
  const itemsEl    = document.getElementById('cart-drawer-items');
  const footerEl   = document.getElementById('cart-drawer-footer');
  const progressEl = document.getElementById('cart-progress-wrap');
  const countEl    = document.getElementById('cart-drawer-count');
  const subtotalEl = document.getElementById('cart-subtotal');
  if (!itemsEl) return;

  const FREE_SHIP = 0;   // Livraison offerte en France dès le premier euro

  // ----- Panier vide -----
  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = `
      <div class="cart-empty-msg" style="text-align:center;padding:60px 30px;">
        <div class="icon" style="font-size:48px;margin-bottom:16px;opacity:0.3;"><svg class="sv-ico" viewBox="0 0 24 24" aria-hidden="true" style="width:44px;height:44px;margin:0 auto"><path d="M5 8h14l-1 13H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg></div>
        <div style="font-family:'Oswald',sans-serif;font-size:18px;letter-spacing:2px;color:#fff;margin-bottom:8px;text-transform:uppercase;">Votre panier est vide</div>
        <p style="font-family:'Barlow',sans-serif;font-size:13px;color:rgba(196,184,150,0.6);line-height:1.6;margin-bottom:24px;">Découvrez les essentiels pour préparer votre foyer.</p>
        <a href="/collections/essentiels-du-foyer" onclick="toggleCart()" style="display:inline-block;background:var(--amber);color:#000;padding:14px 32px;font-family:'Barlow Condensed',sans-serif;font-size:13px;letter-spacing:2.5px;text-transform:uppercase;font-weight:700;text-decoration:none;">Voir les produits</a>
      </div>`;
    if (footerEl)   footerEl.style.display = 'none';
    if (progressEl) progressEl.style.display = 'none';
    if (countEl)    countEl.style.display = 'none';
    return;
  }

  // ----- Panier rempli -----
  if (footerEl)   footerEl.style.display = '';
  if (progressEl) progressEl.style.display = '';

  // Compteur dans le titre
  if (countEl) {
    countEl.textContent = '(' + cart.item_count + ')';
    countEl.style.display = '';
  }

  // Barre de progression livraison offerte
  if (progressEl) {
    if (cart.total_price >= FREE_SHIP) {
      progressEl.innerHTML = `
        <div style="font-family:'Barlow Condensed',sans-serif;font-size:13px;letter-spacing:1.5px;color:var(--amber);text-transform:uppercase;font-weight:700;text-align:center;">
          ✓ LIVRAISON OFFERTE EN FRANCE
        </div>`;
    } else {
      const remaining = FREE_SHIP - cart.total_price;
      let pct = Math.round((cart.total_price * 100) / FREE_SHIP);
      if (pct > 100) pct = 100;
      progressEl.innerHTML = `
        <div style="font-family:'Barlow',sans-serif;font-size:13px;color:rgba(196,184,150,0.85);margin-bottom:8px;text-align:center;line-height:1.5;">
          Plus que <strong style="color:var(--amber);">${formatMoney(remaining)}</strong> pour la <strong>livraison GRATUITE</strong>
        </div>
        <div style="height:6px;background:rgba(255,255,255,0.08);overflow:hidden;border-radius:3px;">
          <div style="height:100%;width:${pct}%;background:linear-gradient(90deg,#d4820a,#e8a040);transition:width 0.4s ease;"></div>
        </div>`;
    }
  }

  // Lignes du panier
  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-line" id="cart-line-${item.key}">
      <a href="${item.url}" class="cart-line-img">
        ${item.image
          ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
          : '📦'
        }
      </a>
      <div class="cart-line-info">
        <a href="${item.url}" style="color:inherit;text-decoration:none;"><div class="cart-line-name">${escapeHtml(item.product_title)}</div></a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:12px;color:var(--sand);opacity:0.6;margin-bottom:4px;">${escapeHtml(item.variant_title)}</div>` : ''}
        <div class="cart-line-price">${formatMoney(item.line_price)}</div>
        <div class="qty-control">
          <button class="qty-btn" onclick="updateCartQty('${item.key}', ${item.quantity - 1})" aria-label="Diminuer">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" onclick="updateCartQty('${item.key}', ${item.quantity + 1})" aria-label="Augmenter">+</button>
          <button onclick="updateCartQty('${item.key}', 0)" aria-label="Supprimer" style="margin-left:auto;background:none;border:none;color:rgba(196,184,150,0.4);font-size:18px;cursor:pointer;padding:4px 8px;transition:color 0.2s;" onmouseover="this.style.color='#ff4444'" onmouseout="this.style.color='rgba(196,184,150,0.4)'">×</button>
        </div>
      </div>
    </div>
  `).join('');

  // Sous-total
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.appendChild(document.createTextNode(str || ''));
  return div.innerHTML;
}

// ===== WISHLIST =====
function addToWishlist(event, productId) {
  event.preventDefault();
  event.stopPropagation();
  const btn = event.currentTarget;
  btn.textContent = '❤️';
  showToast('❤️ Ajouté aux favoris');
  // Ici : intégrer avec Shopify Wishlist API ou app tierce
}

// ===== TOAST =====
function showToast(message, duration = 3000) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), duration);
}

// ===== MOBILE MENU =====
function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  if (!menu) return;
  if (menu.style.display === 'none' || menu.style.display === '') {
    menu.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  } else {
    menu.style.display = 'none';
    document.body.style.overflow = '';
  }
}

// ===== SCROLL ANIMATIONS =====
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  const elements = document.querySelectorAll(
    '.product-card, .category-card, .kit-card, .testimonial-card, .trust-item'
  );

  elements.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = `opacity 0.5s ease ${i * 0.07}s, transform 0.5s ease ${i * 0.07}s`;
    observer.observe(el);
  });
}

// ===== STICKY HEADER SHADOW =====
function initStickyHeader() {
  const header = document.getElementById('header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
      header.style.boxShadow = '0 4px 30px rgba(0,0,0,0.5)';
    } else {
      header.style.boxShadow = 'none';
    }
  }, { passive: true });
}

// ===== PRODUCT IMAGE SWITCHER =====
function switchImage(thumb, src) {
  const mainImg = document.getElementById('main-img-el');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// ===== BUY NOW =====
function buyNow(variantId) {
  window.location.href = `/cart/${variantId}:1?checkout=true`;
}

// ===== PROMO BANNER CLOSE =====
document.addEventListener('click', (e) => {
  if (e.target.classList.contains('banner-close')) {
    const banner = e.target.closest('.promo-banner');
    if (banner) {
      banner.style.maxHeight = banner.scrollHeight + 'px';
      banner.style.transition = 'max-height 0.3s, padding 0.3s, opacity 0.3s';
      requestAnimationFrame(() => {
        banner.style.maxHeight = '0';
        banner.style.padding = '0';
        banner.style.opacity = '0';
        setTimeout(() => banner.remove(), 300);
      });
    }
  }
});

// ===== SELECT VARIANT =====
// Retiré volontairement : le template produit (templates/product.liquid) définit
// sa propre version COMPLÈTE de selectVariant() qui synchronise #pf-variant-id
// (indispensable au bouton de paiement express {{ form | payment_button }}) ET
// conserve le tracking addToCartTracked. Comme survivra.js se charge en dernier,
// sa définition écrasait celle du template et cassait le variant du paiement
// express sur les produits multi-variantes. On laisse donc gagner le template.

// ===== INIT =====
document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initStickyHeader();
  refreshCart(); // Sync cart count + tiroir au chargement
});